import { getDeeplinkRoutingUrls } from './getDeepLinkRoutingUrls';
import { getDiscoverDestinations } from './getDiscoverDestinations';
import { updateDestinationBaseUrl } from './updateDestinationBaseUrl';

export default {
  getDeeplinkRoutingUrls,
  updateDestinationBaseUrl,
  getDiscoverDestinations,
};
